import { render, staticRenderFns } from "./GnbWeb.vue?vue&type=template&id=26807732&scoped=true&"
import script from "./GnbWeb.vue?vue&type=script&lang=js&"
export * from "./GnbWeb.vue?vue&type=script&lang=js&"
import style0 from "./GnbWeb.vue?vue&type=style&index=0&id=26807732&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26807732",
  null
  
)

/* custom blocks */
import block0 from "./GnbWeb.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports